import { useContext } from 'react'

import { EventsContext } from './EventsContext'

export function useEventsFilters() {
  const context = useContext(EventsContext)
  if (!context) throw new Error('useEventsFilters должен вызываться внутри EventsProvider')
  return context
}
